export const packageList = [
  {
    name: 'vts_finance',
    activeRule: ['vts-finance'],
    // preload: true,
  },
  {
    name: 'vts_report',
    activeRule: ['vts-report'],
    // preload: true,
  },
  {
    name: 'vts_vehicle_cargo',
    activeRule: ['vts-vehicle-cargo'],
    // preload: true,
  },
  {
    name: 'vts_capacity',
    activeRule: ['vts-capacity'],
    // preload: true,
  },
  {
    name: 'vts',
    // 未上线：vts-vehicle-track-order, vts-vehicle-bid, vts-base-setting
    activeRule: ['vts', 'vts-common', 'vts-report', 'vts-capacity', 'vts-vehicle-cargo', 'vts-finance'],
    // preload: true,
  },
  {
    name: 'vts_vehicle_bid',
    activeRule: ['vts-vehicle-bid'],
  },
]

export const remoteModuleConfig = {
  dev: ['vts_finance', 'vts_report', 'vts_vehicle_cargo', 'vts_capacity', 'vts', 'vts_vehicle_bid'],
  stg: ['vts_finance', 'vts_report', 'vts_vehicle_cargo', 'vts_capacity', 'vts', 'vts_vehicle_bid'],
  uat: ['vts_finance', 'vts_report', 'vts_vehicle_cargo', 'vts_capacity', 'vts', 'vts_vehicle_bid'],
  prd: ['vts_finance', 'vts_report', 'vts_vehicle_cargo', 'vts_capacity', 'vts', 'vts_vehicle_bid'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/ecs/index.js